import { CanvasMigrationDbStatus } from '../CanvasMigration/canvasMigrationTypes'

const STATUS_LABELS: Record<CanvasMigrationDbStatus, string> = {
  pending: 'Pending',
  in_progress: 'In progress',
  completed: 'Completed',
}

/** Human-readable label for Admin CRM migration status, or null if unset. */
export const formatCanvasMigrationStatusLabel = (
  status: string | null | undefined
): string | null => {
  if (!status) {
    return null
  }
  return STATUS_LABELS[status as CanvasMigrationDbStatus] ?? null
}
